module.exports = __webpack_public_path__ + "static/media/ic_bar_char_decrease.68c6963a.svg";